import React, { Fragment, useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Input, LocaleContext } from 'shared';
import { required } from 'utils/formValidators';

export const AccountName = () => {
  const localeContext = useContext(LocaleContext);

  return (
    <Fragment>
      <Field name="name" validate={required(localeContext.formatMessage({ id: 'FORM.REQUIRED' }))}>
        {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
          <Input
            label={localeContext.formatMessage({ id: 'ACCOUNT.ACCOUNT-NAME' })}
            input={input}
            meta={meta}
            className="acount-form__name"
            maxLenght={40}
            charsCounter={true}
          />
        )}
      </Field>
    </Fragment>
  );
};
